import { render, staticRenderFns } from "./icon-delivery.vue?vue&type=template&id=fbd0ec9a&scoped=true&"
import script from "./icon-delivery.vue?vue&type=script&lang=js&"
export * from "./icon-delivery.vue?vue&type=script&lang=js&"
import style0 from "./icon-delivery.vue?vue&type=style&index=0&id=fbd0ec9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd0ec9a",
  null
  
)

export default component.exports